import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Layout } from "./components/layout/Layout";

// Pages
import { HomePage } from "./pages/HomePage";
import { CommunitiesPage } from "./pages/CommunitiesPage";
import { CommunityDetailPage } from "./pages/CommunityDetailPage";
import { StartupsPage } from "./pages/StartupsPage";
import { StartupDetailPage } from "./pages/StartupDetailPage";
import { EventsPage } from "./pages/EventsPage";
import { EventDetailPage } from "./pages/EventDetailPage";
import { JobsPage } from "./pages/JobsPage";
import { JobDetailPage } from "./pages/JobDetailPage";
import { TopicsPage } from "./pages/TopicsPage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { AboutPage } from "./pages/AboutPage";
import { GetInvolvedPage } from "./pages/GetInvolvedPage";
import { ContactPage } from "./pages/ContactPage";
import { ForumsPage } from "./pages/ForumsPage";
import { BlogPage } from "./pages/BlogPage";
import { NewsletterPage } from "./pages/NewsletterPage";
import { CoworkingPage } from "./pages/CoworkingPage";
import { SuccessStoriesPage } from "./pages/SuccessStoriesPage";
import { PodcastsPage } from "./pages/PodcastsPage";
import { LoginPage } from "./pages/LoginPage";
import { AdminPage } from "./pages/AdminPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/communities" element={<CommunitiesPage />} />
              <Route path="/communities/:id" element={<CommunityDetailPage />} />
              <Route path="/startups" element={<StartupsPage />} />
              <Route path="/startups/:id" element={<StartupDetailPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/:id" element={<EventDetailPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/jobs/:id" element={<JobDetailPage />} />
              <Route path="/topics" element={<TopicsPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/get-involved" element={<GetInvolvedPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/forums" element={<ForumsPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/newsletter" element={<NewsletterPage />} />
              <Route path="/coworking" element={<CoworkingPage />} />
              <Route path="/success-stories" element={<SuccessStoriesPage />} />
              <Route path="/podcasts" element={<PodcastsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
